import { ModalRecupContraComponent } from './../../../seguridad/layouts/modal-recup-contra/modal-recup-contra.component';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RecuperarContrasenaService } from './recuperar-contrasena.service';
import { ConfirmeValidators } from 'src/app/shared/directives/validators/confirme-validators';
import { Router } from '@angular/router';
import { TipoCorreo } from 'src/app/shared/enumeraciones/tipo-correo.enum';

@Component({
	selector: 'app-recuperar-contrasena',
	templateUrl: './recuperar-contrasena.component.html',
	styleUrls: ['./recuperar-contrasena.component.scss']
})
export class RecuperarContrasenaComponent implements OnInit {
	isRecuerdaCorreo: Boolean = true;
	formRecuperarContrasena: FormGroup;
	formRecordarCorreo: FormGroup;
	pistaCorreo: string;

	constructor(private recuperarContrasenaService: RecuperarContrasenaService,
		private modalService: NgbModal, private formBuilder: FormBuilder, private router: Router) {
	}

	ngOnInit() {
		this.formRecuperarContrasena = this.formBuilder.group({
			correo_electronico: ['', [Validators.required, ConfirmeValidators.emailValidator]]
		});
		this.formRecordarCorreo = this.formBuilder.group({
			usuario: ['', Validators.required],
			correo_electronico: ['', [Validators.required, Validators.email]]
		});
	}

	/**
	 * recordarCorreo
	 */
	public recordarCorreo(event: Event) {
		this.isRecuerdaCorreo = false;
	}

	public openModal() {
		this.recuperarContrasenaService
			.update(this.isRecuerdaCorreo ? this.formRecuperarContrasena.value : this.formRecordarCorreo.value).subscribe(result => {
				if (result.result) {
					this.formRecordarCorreo.reset();
					this.formRecuperarContrasena.reset();
					const modalRef = this.modalService.open(ModalRecupContraComponent, { centered: true });
					modalRef.result.then((resultado) => {
						this.recuperarContrasenaService.reenviar({
							...result.data,
							tipo_correo: TipoCorreo.RecuperarClave,
						}).subscribe(res => {
							this.router.navigate(['/home']);
						});
					}).catch(resultado => {
						this.router.navigate(['/home']);
					});
				}
			});
	}

	public onChangePistaCorreo() {
		this.pistaCorreo = null;
		if (this.formRecordarCorreo.value.usuario) {
			this.recuperarContrasenaService
				.getPista(this.formRecordarCorreo.value).subscribe(result => {
					if (result.result) {
						this.pistaCorreo = result.data.correo_electronico;
					} else {

					}
				});
		}
	}
}
